import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';

export const Actions: StyleRule<{
    show?: boolean;
}> = ({ show }) => ({
    zIndex: 1,
    opacity: show ? 1 : 0,
    transition: `opacity 0.4s`,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRow: '1fr',
    columnGap: pxToRem(8),
    minWidth: pxToRem(88),
    padding: pxArrayToRem([0, 8]),
    position: 'absolute',
    right: pxToRem(8),
    alignItems: 'center',

    [`& div.ui-chooseDesignBoardModal`]: {
        position: 'absolute',
    },
});

export const AddButton: StyleRule = () => ({
    gridColumn: '2',
});

export const RemoveButton: StyleRule = () => ({
    '& svg': {
        padding: pxToRem(2),
    },
});
